import sendMarriedDoc from '../../../../api/creditPlatform/sendMarriedDoc';
import HookForm from '../../../../components/HookForm/HookForm';
import DocsInputNew from '../../../../components/Inputs/DocsInput/DocsInputNew';
import UploadProgressBar from '../../../../components/UploadProgressBar';
import useDocumentUpload from '../../../../hooks/useDocumentUpload';
import {
  DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION,
  DOCUMENT_TYPES_MARRIAGE_CONTRACT,
  DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
  DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
  DOCUMENT_TYPES_POWER_OF_ATTORNEY,
  DOCUMENT_TYPES_SPOUSE_CONSENT,
  MARITAL_STATUS_MARRIED,
} from '../../../../constants';
import alert from '../../../../helpers/alert';
import isFileSizeSmallerThan from '../../../../utils/validateFileSize';

const NotarialDocuments = ({
  backHandler,
  loading,
  deal,
  documents,
  chosenBankAppealId,
  setLoading,
  onSuccess,
  bankId,
  preferentialLoan,
}) => {
  const { uploadMultiple, uploading, progress, currentFileName, uploadQueue } = useDocumentUpload();
  const maritalStatus = deal?.creditAppeal?.maritalStatus;
  const isMarried = maritalStatus === MARITAL_STATUS_MARRIED;

  const onNotarialDocumentsSubmit = async (values) => {
    const hasMarriageContract = Boolean(values['ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ']);
    const hasSpouseConsent = Boolean(values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ']);
    const hasExtrajudicialEnforcement = Boolean(values['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾']);

    if (isMarried && !preferentialLoan) {
      if (hasMarriageContract && !hasExtrajudicialEnforcement) {
        alert.error('ÐÐ»Ñ ÐºÐ»Ð¸ÐµÐ½ÑÐ° Ñ Ð±ÑÐ°ÑÐ½ÑÐ¼ ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ¾Ð¼ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ Ð·Ð°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾');
        return;
      }

      if (!hasMarriageContract && !hasSpouseConsent) {
        alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾');
        return;
      }
    }

    // if (preferentialLoan) {
    //   if (!values['originCertificate']) {
    //     alert.error('ÐÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÑ ÑÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ð¸ ÑÐ¾Ð²Ð°ÑÐ°');
    //     return;
    //   }
    // }

    if (hasSpouseConsent && !isFileSizeSmallerThan(values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ'], 10)) {
      alert.error('Ð Ð°Ð·Ð¼ÐµÑ ÑÐ°Ð¹Ð»Ð° ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ðµ Ð´Ð¾Ð»Ð¶ÐµÐ½ Ð¿ÑÐµÐ²ÑÑÐ°ÑÑ 10 ÐÐ');
      return;
    }

    const filesToUpload = [
      values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_SPOUSE_CONSENT, file: values['ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ'] },
      values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_POWER_OF_ATTORNEY,
        file: values['Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ'],
      },
      values['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_OUT_OF_COURT_CAR_SALE,
        file: values['ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾'],
      },
      values['ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_MARRIAGE_CONTRACT,
        file: values['ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ'],
      },
      values['originCertificate'] && {
        dealId: deal?.id,
        fileTypeId: DOCUMENT_TYPES_ORIGIN_CERTIFICATE,
        file: values['originCertificate'],
      },
      // values['customsClearanceConfirmation'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_CUSTOMS_CLEARANCE_CONFIRMATION, file: values['customsClearanceConfirmation'] },
      // values['extendedProducerResponsibilityConfirmation'] && { dealId: deal?.id, fileTypeId: DOCUMENT_TYPES_EXTENDED_PRODUCER_RESPONSIBILITY_CONFIRMATION, file: values['extendedProducerResponsibilityConfirmation'] },
    ].filter(Boolean);

    try {
      await uploadMultiple(filesToUpload);
      setLoading(true);
      onSuccess(values);
    } catch (err) {
      alert.error('ÐÑÐ¸Ð±ÐºÐ° Ð·Ð°Ð³ÑÑÐ·ÐºÐ¸ Ð´Ð¾ÐºÑÐ¼ÐµÐ½ÑÐ¾Ð²');
      setLoading(false);
    }
  };

  if (uploading) {
    return <UploadProgressBar progress={progress} fileName={currentFileName} queue={uploadQueue} />;
  }

  return (
    <div>
      <HookForm
        title={'ÐÐ¾ÐºÑÐ¼ÐµÐ½ÑÑ'}
        hint="ÐÑÐ¾ÐºÐ¾Ð½ÑÑÐ»ÑÑÐ¸ÑÑÐ¹ÑÐµ ÐºÐ»Ð¸ÐµÐ½ÑÐ° ÐºÐ°ÐºÐ¸Ðµ Ð¸Ð¼ÐµÐ½Ð½Ð¾ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸ Ð¸ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ñ Ð½Ð°Ð´Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ. ÐÑÐ¶Ð½Ð¾ ÑÑÐ¾Ð±Ñ ÐºÐ»Ð¸ÐµÐ½Ñ Ð·Ð°Ð¿ÑÐ°ÑÐ¸Ð²Ð°Ð» ÑÐ°Ð²Ð½Ð¾Ð·Ð½Ð°ÑÐ½Ð¾ÑÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸, ÑÑÐ¾ Ð½ÐµÐ¾Ð±ÑÐ¾Ð´Ð¸Ð¼Ð¾ Ð´Ð»Ñ ÑÐ¾Ð³Ð¾, ÑÑÐ¾Ð±Ñ Ð¼Ð¾Ð¶Ð½Ð¾ Ð±ÑÐ»Ð¾ Ð²ÑÐ¿Ð¸ÑÐ°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ñ Ð»ÑÐ±Ð¾Ð³Ð¾ Ð½Ð¾ÑÐ°ÑÐ¸ÑÑÐ°.   Ð¢Ð°Ðº Ð¶Ðµ Ð½ÑÐ¶Ð½Ð¾ Ð¾Ð¿Ð¸ÑÐ°ÑÑ Ð½Ð° ÐºÐ¾Ð³Ð¾ Ð½ÑÐ¶Ð½Ð¾ ÑÐ´ÐµÐ»Ð°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÑ Ð½Ð° ÑÑÐµÑ. ÐÑÐ¿Ð¸ÑÐ°ÑÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð½Ð° ÑÐµÐ³Ð¸ÑÑÑÐ°ÑÐ¸Ð¾Ð½Ð½ÑÐµ Ð´ÐµÐ¹ÑÑÐ²Ð¸Ñ Ð½ÑÐ¶Ð½Ð¾ Ð½Ð° Ð¤ÐÐ, ÐÐÐ ÑÐµÐ»Ð¾Ð²ÐµÐºÐ°."
        grid={{ display: 'grid', gap: 20 }}
        action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
        inputs={[
          {
            text: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ',
            id: 'Ð¡Ð¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            component: DocsInputNew,
            rules: {
              deps: ['ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ'],
              validate: (value, getValues) => {
                if(!preferentialLoan) return true;
                if (!isMarried) {
                  return true;
                }

                const marriageContract = getValues('ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ');
                if (!marriageContract && !value) {
                  return 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÐµ ÑÐ¾Ð³Ð»Ð°ÑÐ¸Ðµ ÑÑÐ¿ÑÑÐ³Ð° (ÑÑÐ¿ÑÑÐ³Ð¸) Ð¸Ð»Ð¸ Ð±ÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ';
                }

                return true;
              },
            },
          },
          {
            text: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            id: 'ÐÐ°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾',
            component: DocsInputNew,
            rules: {
              deps: ['ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ'],
              validate: (value, getValues) => {
                if (!isMarried) {
                  return true;
                }

                const marriageContract = getValues('ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ');
                if (marriageContract && !value) {
                  return 'ÐÑÐ¸ Ð½Ð°Ð»Ð¸ÑÐ¸Ð¸ Ð±ÑÐ°ÑÐ½Ð¾Ð³Ð¾ ÐºÐ¾Ð½ÑÑÐ°ÐºÑÐ° Ð·Ð°Ð³ÑÑÐ·Ð¸ÑÐµ Ð·Ð°ÑÐ²Ð»ÐµÐ½Ð¸Ðµ Ð½Ð° Ð²Ð½ÐµÑÑÐ´ÐµÐ±Ð½ÑÑ ÑÐµÐ°Ð»Ð¸Ð·Ð°ÑÐ¸Ñ Ð°Ð²ÑÐ¾';
                }

                return true;
              },
            },
          },
          {
            text: 'ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ',
            id: 'ÐÑÐ°ÑÐ½ÑÐ¹ ÐºÐ¾Ð½ÑÑÐ°ÐºÑ',
            component: DocsInputNew,
          },
          {
            text: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ',
            id: 'ÐÐ¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÑ Ð¿Ð¾ÑÑÐ°Ð½Ð¾Ð²ÐºÐ¸ Ð½Ð° ÑÑÐµÑ',
            component: DocsInputNew,
          },
          {
            text: 'Ð¡ÐµÑÑÐ¸ÑÐ¸ÐºÐ°Ñ Ð¾ Ð¿ÑÐ¾Ð¸ÑÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ð¸ ÑÐ¾Ð²Ð°ÑÐ° (ÑÐ¾ÑÐ¼Ð° Ð¡Ð¢-KZ) Ð´Ð»Ñ Ð°Ð²ÑÐ¾ Ð¾ÑÐµÑÐµÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´ÑÑÐ²Ð° Ð´Ð¾ 2025Ð³ Ð²ÑÐ¿ÑÑÐºÐ°  Ð¸Ð»Ð¸ ÐÐ´Ð¾Ð±ÑÐµÐ½Ð¸Ðµ ÑÐ¸Ð¿Ð° ÑÑÐ°Ð½ÑÐ¿Ð¾ÑÑÐ½Ð¾Ð³Ð¾ ÑÑÐµÐ´ÑÑÐ²Ð° (ÐÐ¢Ð¢Ð¡) Ð´Ð»Ñ Ð°Ð²ÑÐ¾ Ð¾ÑÐµÑÐµÑÑÐ²ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´ÑÑÐ²Ð°, Ð½Ð°ÑÐ¸Ð½Ð°Ñ Ñ 2026Ð³ Ð²ÑÐ¿ÑÑÐºÐ°',
            label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
            name: 'originCertificate',
            id: 'originCertificate',
            component: DocsInputNew,
            // required: preferentialLoan,
          },
          // {
          //   text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ',
          //   label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
          //   name: 'customsClearanceConfirmation',
          //   id: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¿ÑÐ¾ÑÐ¾Ð¶Ð´ÐµÐ½Ð¸Ðµ ÑÐ°Ð¼Ð¾Ð¶ÐµÐ½Ð½Ð¾Ð³Ð¾ Ð¾ÑÐ¾ÑÐ¼Ð»ÐµÐ½Ð¸Ñ',
          //   component: DocsInputNew,
          // },
          // {
          //   text: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸ (Ð¸Ð¼Ð¿Ð¾ÑÑÐµÑÐ°Ð¼Ð¸)',
          //   label: 'ÐÐ°Ð³ÑÑÐ·Ð¸ÑÑ Ð´Ð¾ÐºÑÐ¼ÐµÐ½Ñ',
          //   name: 'extendedProducerResponsibilityConfirmation',
          //   id: 'ÐÐ¾ÐºÑÐ¼ÐµÐ½Ñ Ð¿Ð¾Ð´ÑÐ²ÐµÑÐ¶Ð´Ð°ÑÑÐ¸Ð¹ Ð¸ÑÐ¿Ð¾Ð»Ð½ÐµÐ½Ð¸Ðµ ÑÐ°ÑÑÐ¸ÑÐµÐ½Ð½ÑÑ Ð¾Ð±ÑÐ·Ð°ÑÐµÐ»ÑÑÑÐ² Ð¿ÑÐ¾Ð¸Ð·Ð²Ð¾Ð´Ð¸ÑÐµÐ»ÑÐ¼Ð¸ (Ð¸Ð¼Ð¿Ð¾ÑÑÐµÑÐ°Ð¼Ð¸)',
          //   component: DocsInputNew,
          // },
          {
            label: 'ÐÐ¾Ð¼ÐµÑ Ð´Ð¾Ð²ÐµÑÐµÐ½Ð½Ð¾ÑÑÐ¸',
            name: 'powerOfAttorneyNumber',
          },
        ]}
        onSubmit={onNotarialDocumentsSubmit}
        loading={loading}
        backHandler={backHandler}
      />
    </div>
  );
};

export default NotarialDocuments;
